<template>
  <div>
    <div class="py-4 container-fluid" style="width: 98%; margin: 1vw">
      <div  class="gridWrap">
        <div class="gridItem">
          <p class="sectionTitle">
            등록 병원 수
          </p>
          <div class="numberArea" id="hos">
            0
          </div>
        </div>
        <div class="gridItem">
          <p class="sectionTitle">
            등록 병원 계정 수
          </p>
          <div class="numberArea" id="hosAcc">
            0
          </div>
        </div>
        <div class="gridItem">
          <p class="sectionTitle">
            등록 제조사 수
          </p>
          <div class="numberArea" id="manu">
            0
          </div>
        </div>
        <div class="gridItem">
          <p class="sectionTitle">
            등록 제조사 계정 수
          </p>
          <div class="numberArea" id="manuAcc">
            0
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { addCommaToNumber } from "../utils/utils";
export default {
  name: "dashboard",
  data() {
    return {
      totalHospitals: 0,
      totalHospitalAccounts: 0,
      totalManufacturer: 0,
      totalManufacturerAccounts: 0,
    };
  },
  computed: {
    
  },
  components: {

  },
  async mounted() {
    await this.getDashboardData();
    this.animateNumber("#hos", this.totalHospitals);
    this.animateNumber("#hosAcc", this.totalHospitalAccounts);
    this.animateNumber("#manu", this.totalManufacturer);
    this.animateNumber("#manuAcc", this.totalManufacturerAccounts);
  },
  
  methods: {
    // 대시보드 데이터 가져오기
    async getDashboardData() {
      try {
        const response = await this.$apiInstance.get(`/companies/certilife/dashboard`);
        if(response.status === 200 || response.status === 201) {
          const { data } = response;
          this.totalHospitals = data.totalHospitals;
          this.totalHospitalAccounts = data.totalHospitalAccounts;
          this.totalManufacturer = data.totalManufacturer;
          this.totalManufacturerAccounts = data.totalManufacturerAccounts;
        }
      } catch(error) {
        console.log(error);
      }
    },

    // 콤마 추가
    addCommaToNumber,

    // 숫자 올라가는 효과
    animateNumber(elementName, targetNumber){
    	const element = document.querySelector(elementName)
      if(element) {
        if(targetNumber === 0){
          element.innerHTML = "0";
        } else {
          const each = Math.ceil(targetNumber / 33);
          let time = 0
          
          for(let i = 0; i <= targetNumber; i += each){
            setTimeout(() => {
              element.innerHTML = addCommaToNumber(i);
            }, 20 * time);
            if(i + each > targetNumber){
              setTimeout(() => {
                element.innerHTML = addCommaToNumber(targetNumber);
              }, 20 * (time + 1));
            }
            time++;
          }
        }
      }
      
  	},
  },
};
</script>
<style>

  .gridWrap {
    width: 80%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 5%;
    height: 80vh;
  }

  .gridItem {
    width: 100%;
    height: 100%;
    border: 1px solid black;
    position: relative;
  }

  .sectionTitle {
    font-size: 24px;
    color: black;
    margin-top: 2rem;
    margin-left: 2rem;
  }

  .numberArea {
    color: black;
    font-size: 40px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: 700;
  }
</style>
<style>

  .gridWrap {
    width: 80%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 5%;
    height: 80vh;
  }

  .gridItem {
    width: 100%;
    height: 100%;
    border: 1px solid black;
    position: relative;
  }

  .sectionTitle {
    font-size: 24px;
    color: black;
    margin-top: 2rem;
    margin-left: 2rem;
  }

  .numberArea {
    color: black;
    font-size: 40px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: 700;
  }
</style>